import { useAirKeyTracePageView } from '@/utils/airKeyTrace';
import { cn } from '@/utils/cn';
import { FlexContainer } from '@cof/omni-react';
import styled from '@emotion/styled';

const ErrorScreenTitle = styled('h3')<{ fontSize: number }>`
  font-size: ${(props) => props.fontSize}px;
  font-weight: 600;
  padding: 0 32px;
  align-self: flex-start;
`;

const ErrorScreenHeader = styled('header')`
  width: 100vw;
  padding: 32px 32px 32px;
  display: flex;
  justify-content: center;
`;

const ErrorScreenBody = styled('div')`
  white-space: pre-line;
  padding: 0px 32px 32px;
  align-self: flex-start;
`;

export const ErrorScreen = () => {
  useAirKeyTracePageView('error');

  return (
    <FlexContainer
      data-testid="ErrorScreen"
      className={cn('bg-page')}
      direction="column"
      alignItems="center"
      padding="large"
    >
      <FlexContainer direction="column" alignItems="center">
        <ErrorScreenHeader data-testid="MessageScreen--Header">
          <img
            src={'/assets/C1.svg'}
            width={96}
            alt="logo"
            role="presentation"
          />
        </ErrorScreenHeader>

        <img
          src={'/assets/snag.svg'}
          width={96}
          alt="icon"
          role="presentation"
          data-testid="snag-icon"
        />

        <ErrorScreenTitle fontSize={25} className={cn('text-neutral-primary')}>
          We hit a snag
        </ErrorScreenTitle>

        <ErrorScreenBody className={cn('text-neutral-primary')}>
          Please try again later.
        </ErrorScreenBody>
      </FlexContainer>
    </FlexContainer>
  );
};
